import { jsx as _jsx } from "react/jsx-runtime";
import { getItemMetadataAttributes } from '../../utils/item-metadata/get-item-metadata-attributes';
export const ItemMetadataInjector = ({ itemId, metadata, children, className, wrapperTag = 'span', }) => {
    const dataAttributes = getItemMetadataAttributes(itemId, metadata);
    const Tag = wrapperTag;
    return (_jsx(Tag, { className: className, ...dataAttributes, children: children }));
};
